
<template>
    <div class="passwordturnover">
        <v-container>
          <v-row class="text-center" align="center" align-self="center">

            <v-col md="6" offset-md="3">
              <v-card class="overflow-hidden mt-12" >
                  <v-toolbar flat color="secondary">

                    <v-toolbar-title class="font-weight-light white--text" >
                      {{$t('administration.user.passwordturnover')}}
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-card-subtitle>
                    {{$t('administration.user.passwordturnovermessage')}}
                  </v-card-subtitle>

                  <PasswordTurnoverForm class="pa-6" ref="PasswordTurnoverForm" :values="item" :errors="violations" />
                  <v-divider></v-divider>
                  <v-card-actions class="pa-6">
                      <v-spacer></v-spacer>
                      <v-btn
                        @click="updatePassword"
                        color="primary"
                      >
                        {{$t('global.update')}}
                      </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
       </v-container>
       <Loading :visible="isLoading" />
    </div>
</template>
<script>
  import { createHelpers } from 'vuex-map-fields';
  import { mapActions, mapState } from 'vuex';
  import PasswordTurnoverForm from '../../components/login/PasswordUpdate.vue';
  import Loading from '../../components/Loading';
  import NotificationMixin from '../../mixins/NotificationMixin';

  const servicePrefix = 'User';

  const { mapFields } = createHelpers({
    getterType: 'user/getField',
    mutationType: 'user/updateField'
  });

  export default {
    name: 'PasswordTurnover',
    servicePrefix,
    mixins: [NotificationMixin],
    components: {
      Loading,
      PasswordTurnoverForm
    },
    computed: {
      ...mapFields(['error', 'isLoading', 'created', 'violations']),
      ...mapState('user', {
        actioned: 'actioned',
        action: 'action',
        error: 'error',
        isLoading: 'isLoading',
      })
    },
    data() {
      return {
        item: {}
      };
    },
    created: function(){
      if (!this.$root.passwordTurnover) {
        console.log("redirect home");
        this.$router.push({ name: `Home` });
      }
    },
    methods: {
      updatePassword() {

        const PasswordTurnoverForm = this.$refs.PasswordTurnoverForm;
        PasswordTurnoverForm.$v.$touch();
        if (!PasswordTurnoverForm.$v.$invalid) {
          this.userPushAction({action: 'edit/password',values: {'oldPassword' :PasswordTurnoverForm.$v.item.$model.oldPassword, 'plainPassword' : PasswordTurnoverForm.$v.item.$model.plainPassword}});
        } else {
          console.log('error');
        }
      },
      ...mapActions({
        userPushAction: 'user/action'
      }),

      updatedPassword(item) {
        console.log(item);
        this.$root.isConnected = true;
        this.$root.passwordTurnover = false;
      //  this.$router.push({ name: `Home` });
        console.log("updatedPassword");
        this.showMessage(this.$t('global.updated'));
        window.location.reload(false);
      },

    },
    watch: {
      actioned(actioned) {
        if (!actioned) {
          return;
        }
        if (this.action == 'edit/password') {
          this.updatedPassword(actioned);
        }
      },

      error(message) {
        message && this.showError(message);
      }
    }
  }
</script>
